# Prop or 0
fallbackToZero = (prop) ->
  Em.computed prop, ->
    @get(prop) ? 0

# дельты должны быть значительно меньше промежутков
# processing, cooking, transportation, чтобы избежать
# неопределенного поведения
CONFIRM_DEADLINE_DELTA = 5
PAYMENT_DEADLINE_DELTA = 5
COURIER_DEADLINE_DELTA = 5

RESTAURANT_CONFIRM_DEADLINE_DELTA = 5

OrderNotificationsMixin = require 'utils/order-checkpoints'

# ---
# Order model
# ---
Order = DS.Model.extend Em.merge OrderNotificationsMixin,
  created_at     : DS.attr 'date'
  updated_at     : DS.attr 'date'
  number         : DS.attr 'string'
  status         : DS.attr 'string'

  source:          DS.attr 'string'
  payment_source:  DS.attr 'string'
  payment_pay_url: DS.attr 'string'

  isPaymentCard:   Em.computed.equal('payment_source', 'card')
  isPaymentCash:         Em.computed.equal('payment_source', 'cash')
  isPaymentCourierCard:  Em.computed.equal('payment_source', 'courier_card')
  isPaymentDeliveryClub: Em.computed.equal('payment_source', 'delivery_club_card_online')

  payment_success:  DS.attr 'mixed'

  takeaway: DS.attr 'boolean'
  dine_in:  DS.attr 'boolean'

  cutlery          : DS.attr 'number'
  tag              : DS.attr 'string'
  staff_comment    : DS.attr 'string'

  ###
  # Цены
  ###
  change           : DS.attr 'number'
  total            : DS.attr 'number'
  final_sum        : DS.attr 'number'
  items_sum        : DS.attr 'number'
  discount_sum     : DS.attr 'number'
  commission_sum   : DS.attr 'number'
  extra_multiplier : DS.attr 'number'

  currency:  DS.attr 'mixed'

  ###
  # Бонусы
  ###
  used_bonuses     : DS.attr 'number'

  ###
  # Доставка
  ###
  delivery_price : DS.attr 'number'
  delivery_at    : DS.attr 'date'
  delivery_asap  : DS.attr 'boolean'

  timezone       : DS.attr 'string'

  ###
  # Чекпоинты курьера по геолокации
  ###
  courier_confirmed_at                    : DS.attr 'date'
  courier_entered_client_area_at          : DS.attr 'date'
  courier_entered_restaurant_area_at      : DS.attr 'date'
  courier_left_client_area_at             : DS.attr 'date'
  courier_left_restaurant_area_at         : DS.attr 'date'
  courier_returned_to_restaurant_area_at  : DS.attr 'date'

  ###
  # Списание заказа
  ###
  shelf_life_till : DS.attr 'date'

  ###
  # Контактные данные
  ###
  contact_name   : DS.attr 'string'
  contact_phone  : DS.attr 'string'
  client_notification_type_call : DS.attr 'boolean'

  ###
  # Оценка
  ###
  client_rate   : DS.attr 'number'
  client_claim  : DS.attr 'string'

  ###
  # Причина отмены
  ###
  cancel_reason   : DS.attr 'string'
  cancel_reason_comment  : DS.attr 'string'

  ###
  # Адрес
  ###

  # Содержит полностью сформатированный адрес, использовать для
  # вывода в интерфейсе
  address_text   : DS.attr 'string'

  # Редактируемые компоненты адреса
  address        : DS.attr 'string'
  address_comment: DS.attr 'string'
  houseNumberError: DS.attr 'boolean'
  city           : DS.attr 'string'
  apartment      : DS.attr 'string'
  staircase      : DS.attr 'string'
  floor          : DS.attr 'string'
  doorphone      : DS.attr 'string'

  coordinates    : DS.attr 'string'
  latitude       : DS.attr 'number'
  longitude      : DS.attr 'number'
  description    : DS.attr 'string'
  block          : DS.attr 'string'
  house          : DS.attr 'string'
  street         : DS.attr 'string'
  street_type    : DS.attr 'string'

  used_promo_code : DS.attr 'string'
  accepts_promo_codes : DS.attr 'boolean'

  # Картографические свойства
  lat: Ember.computed.alias 'latitude'
  lng: Ember.computed.alias 'longitude'
  markerIcon: L.icon
    iconUrl: '/images/map-markers/dots/order-marker.png'
    iconSize: [26, 28]
    iconAnchor: [13, 14]
    popupAnchor: [0, -14]
  isReadyToDrawOnMap: Ember.computed.and 'lat', 'lng'

  ###
  # Внешние связи
  ###
  organization   : DS.belongsTo 'organization',  async: true
  delivery_zone  : DS.belongsTo 'delivery_zone', async: true
  restaurant     : DS.belongsTo 'restaurant',    async: true
  table          : DS.belongsTo 'table',         async: true
  courier        : DS.belongsTo 'courier',       async: true
  user           : DS.belongsTo 'user',          async: true
  # payment        : DS.belongsTo 'payment',       async: true
  client         : DS.belongsTo 'client',        async: true

  courier_confirmed_at:    DS.attr 'date'
  restaurant_confirmed_at: DS.attr 'date'
  confirmed_at:            DS.attr 'date'
  published_at:            DS.attr 'date'

  ###
  # Содержимое заказа
  ###
  items:   DS.hasMany 'order_item',    async: true
  buddies: DS.hasMany 'order_buddies', async: true
  bonuses: DS.hasMany 'order_bonuses', async: true


  messages: DS.hasMany 'order_message', async: true
  external_delivery:  DS.attr 'mixed'
  integration_params: DS.attr 'mixed'

  parent_id: DS.attr 'number'
  childs:    DS.hasMany 'order', async: true

  promos:    DS.attr 'mixed'

  deliveryType: ((key, value) ->
    value = value + ''

    if arguments.length > 1
      switch value
        when 'dine_in'  then @set('dine_in', true);  @set('takeaway', false)
        when 'takeaway' then @set('dine_in', false); @set('takeaway', true)
        when 'delivery' then @set('dine_in', false); @set('takeaway', false)

    return 'dine_in' if @get('dine_in')
    return 'takeaway' if @get('takeaway')
    'delivery'
  ).property('dine_in','takeaway')

  delivery: (->
    !@get('dine_in') && !@get('takeaway')
  ).property('dine_in', 'takeaway')

  shelf_life_till_human: (->
    date = moment(@get('shelf_life_till')).tz(@get('timezone'))
    return null unless date
    date.format('H:mm')
  ).property('shelf_life_till')

  selectBonusDish: (bonus, dish) ->
    @nonRESTAction('POST', 'select_bonus_dish', {bonus_id: bonus, dish_id: dish})

  geocode: ->
    @nonRESTAction('POST', 'geocode')

  reverseGeocode: ->
    @nonRESTAction('POST', 'reverse_geocode')

  dispose: ->
    @nonRESTAction('POST', 'dispose')
    .then =>
      @reload()


  assignZone: ->
    @nonRESTAction('POST', 'assign_zone')

  # ---
  # Оценка звездами
  # ---
  clientRateSting: (->
    ret = ''
    rate = @get('client_rate')
    while rate-- > 0
      ret += '★'
    ret

  ).property('client_rate')

  clientCanRate: (->
    @get('session.rateEnabled')
  ).property('session.rateEnabled')

  contactPhoneNumbers: (->
    "#{@get('contact_phone')}".replace(/[^+\d]/g,'')
  ).property('contact_phone')

  normalStatus: (->
    switch @get('status')
      when 'draft'     then 'draft'
      when 'pending'   then 'new'
      when 'confirm'   then 'confirmed'
      when 'preparing' then 'preparing'
      when 'prepared'  then 'prepared'
      when 'delivery'  then 'delivery'
      when 'complete'  then 'completed'
      when 'undo'      then 'canceled'
  ).property('status')

  # У заказа отличный от пользователя часовой пояс
  timezone_differs: (->
    tz = @get('timezone')
    return null if moment.tz.zone(tz).offset((new Date).valueOf()) == (new Date).getTimezoneOffset()
    tz
  ).property('timezone')

  hasActiveExternalDelivery: (->
    # && @get('external_delivery.external_id')
    @get('external_delivery.is_active')
  ).property('external_delivery', 'external_delivery.is_active')

  receipt: ->
    @nonRESTAction('GET', 'receipt', {dataType: 'html'})

  validate: ->
    @nonRESTAction('PUT', 'validate')

  place: ->
    @nonRESTAction('POST', 'place')

  changeStatus: (newStatus, options={}) ->
    @set('status', newStatus)
    @nonRESTAction('PUT', 'status', Em.merge({ status: newStatus}, options))

  loadLogs: ->
    @nonRESTAction('GET', 'logs')

  # Некоторые расширения воспринимают номер заказа как
  # телефонный номер
  formattedNumber: Em.computed(
    'number',
    ->
      String(@get('number')).replace(/-/g, '―')
  )

  # ----
  # Для расчета динамических свойств во времени
  # ----
  monitor: Em.inject.service('orderMonitor')
  session: Em.inject.service()

  isDraft: Em.computed.equal('status', 'draft')

  extendedComment: (->
    [  @get('address_comment'), @get('description') ].filter( (s) -> !Em.isEmpty(s)).join('\n')
  ).property('description', 'address_comment')

  # ---
  # Время доставки, время приготовления, время транспортировки
  # в минутах
  # ---
  delivery_time:       DS.attr 'number'
  cooking_time:        DS.attr 'number'
  transportation_time: DS.attr 'number'

  deliveryTime:       fallbackToZero('delivery_time')
  cookingTime:        fallbackToZero('cooking_time')
  transportationTime: fallbackToZero('transportation_time')

  pick_up_at: DS.attr 'date'
  cooking_start_at: DS.attr 'date'

  # ---
  # Время, к которому должна начаться обработка заказа:
  # после этого времени заказ больше не отложенный
  #   = delivery_at - delivery_time
  # ---
  processingStartAt: (->
    deliveryTime = @get('deliveryTime')

    moment(@get('delivery_at'))
      .subtract(deliveryTime, 'minutes')
      .toDate()
  ).property(
    'delivery_at',
    'deliveryTime')


  # ---
  # После ли точки начала обработки?
  # ---
  isDelayedTime: (->
    if @get('delivery_asap')
      # ASAP заказы будут в отложенных только если до начала обработки более 2 часов
      undelayAt = moment(@get('processingStartAt')).subtract(120, 'minutes')
    else
      # к точному времени — во время процессинга, но с запасом на период обновления чекпоинтов
      delta = parseInt(localStorage.getItem('monitorCheckInterval'))
      undelayAt = moment(@get('processingStartAt')).subtract(delta, 'minutes')

    # Расчетное время появления еще не наступило
    moment(@get('monitor.globalTime')).isBefore(undelayAt)
  ).property(
    'monitor.globalTime',
    'processingStartAt',
    'delivery_asap')

  isDelayed: (->
    @get('isDelayedTime') and @get('status') is 'confirm' or @get('isUnpaidPending')
  ).property('status', 'isDelayedTime', 'isUnpaidPending')

  isUnpaid: (->
    @get('isPaymentCard') and !@get('payment_success') and @get('final_sum') != 0
  ).property('isPaymentCard', 'payment_success', 'final_sum')

  isUnpaidPending: (->
    @get('env.features.hideUnpaidOrdersInSuspended') and
    @get('status') is 'pending' and @get('isPaymentCard') and
    !@get('payment_success') and @get('final_sum') != 0
  ).property('status', 'isPaymentCard', 'payment_success', 'env.features.hideUnpaidOrdersInSuspended','final_sum')


  # ---
  # Дедлайны
  # ---
  confirmDeadlineAt: (->
    moment(@get('published_at'))
      .add(CONFIRM_DEADLINE_DELTA, 'minutes')
      .toDate()
  ).property('published_at')

  cookingStartDeadlineAt: (->
    moment(@get('pick_up_at'))
      .subtract(@get('cookingTime'), 'minutes')
      .toDate()
  ).property(
    'pick_up_at',
    'cookingTime')

  restaurantConfirmDeadlineAt: (->
    return null unless @get('confirmed_at')

    moment(@get('confirmed_at'))
      .add(RESTAURANT_CONFIRM_DEADLINE_DELTA, 'minutes')
      .toDate()
  ).property('confirmed_at')

  courierCheckpointsText: (->
    return null unless @get('courier_entered_client_area_at') ||
      @get('courier_entered_restaurant_area_at') ||
      @get('courier_left_client_area_at') ||
      @get('courier_left_restaurant_area_at') ||
      @get('courier_returned_to_restaurant_area_at')

    # todo i18n
    "Курьер подошел к ресторану: #{@dateAtHuman @get('courier_entered_restaurant_area_at')}\n" +
    "Курьер вышел из ресторана: #{@dateAtHuman @get('courier_left_restaurant_area_at')}\n" +
    "Курьер подошел к клиенту: #{@dateAtHuman @get('courier_entered_client_area_at')}\n" +
    "Курьер вышел от клиента: #{@dateAtHuman @get('courier_left_client_area_at')}\n" +
    "Курьер вернулся в ресторан: #{@dateAtHuman @get('courier_returned_to_restaurant_area_at')}\n"

  ).property(
    'courier_entered_client_area_at',
    'courier_entered_restaurant_area_at',
    'courier_left_client_area_at',
    'courier_left_restaurant_area_at',
    'courier_returned_to_restaurant_area_at'
  )

  courierOrExternalDeliveryActive: Em.computed.or('courier.id','external_delivery.is_active')

  paymentDeadlineAt: (->
    moment(@get('pick_up_at'))
      .add(PAYMENT_DEADLINE_DELTA, 'minutes')
      .toDate()
  ).property('pick_up_at')

  courierDeadlineAt: (->
    moment(@get('processingStartAt'))
      .add(COURIER_DEADLINE_DELTA, 'minutes')
      .toDate()
  ).property('processingStartAt')

  createdAtHumanDate: (->
    m = moment(@get('published_at')).tz(@get('timezone'))

    if moment().isSame(m, 'day')
      # todo i18n
      return m.format('сегодня в H:mm')
    yesterday = moment().subtract(1, 'day')
    if yesterday.isSame(m, 'day')
      # todo i18n
      return m.format('вчера в H:mm')
    m.format('D MMMM YYYY в H:mm')
  ).property('published_at')

  dateAtHuman: (date) ->
    return '—' unless date
    m = moment(date)

    if moment().isSame(m, 'day')
      # todo i18n
      return m.format('сегодня в H:mm')
    yesterday = moment().subtract(1, 'day')
    if yesterday.isSame(m, 'day')
      # todo i18n
      return m.format('вчера в H:mm')
    m.format('D MMMM YYYY в H:mm')

  cookingEndDeadlineAt:    Em.computed.alias('pick_up_at')
  deliveryStartDeadlineAt: Em.computed.alias('pick_up_at')
  deliveryEndDeadlineAt:   Em.computed.alias('delivery_at')

  orderMapSortWeight: (->
    return 4 if (@get('status') is 'pending')
    return 3 if (@get('status') is 'confirm')
    return 2 if @get('hasProblems')
    return 1
  ).property('hasProblems', 'status')


  env:   Em.inject.service('environment')

  translatedSource: (->
    source = "clients.order_source.#{@get('source')}"
    if @get('env').has_translation_for(source)
      @get('env').translate(source)
    else
      @get('source')
  ).property('source', 'env')

  deliveryNextDay: (->
    deliveryDate = moment(@get('delivery_at')).tz(@get('timezone'))
    return false unless deliveryDate

    now = moment().tz(@get('timezone'))
    return true if deliveryDate.isAfter(now, 'day')

    false
  ).property('delivery_at', 'timezone')

  orderTags: (->
    @get('env.features.orderTags')
  ).property('env.features.orderTags')

  orderStatus: (->
    @get('env').translate("order.status.#{@get('status')}")
  ).property('status')

  staffCommentEnabled: (->
    @get('env.features.orderStaffCommentEnabled')
  ).property('env.features.orderStaffCommentEnabled')

  external_delivery_status: (->
    s = @get('external_delivery.status')
    s = 'idle' if s == null

    statusTexts =
      'idle':             'заявка не создана'
      'claim_created':    'идет поиск курьера'
      'problem':          'проблема'
      'courier_assigned': 'курьер назначен'
      'delivering':       'идет доставка'
      'delivered':        'заказ доставлен'

    return statusTexts[s]
  ).property('external_delivery.status')

  external_delivery_error: (->
    s = @get('external_delivery.status')
    s == 'problem' || s == 'canceled'
  ).property('external_delivery.status')

  external_delivery_success_processing: (->
    s = @get('external_delivery.status')
    s == 'courier_assigned' || s == 'delivering' || s == 'delivered'
  ).property('external_delivery.status')

  external_delivery_courier_info: (->
    [@get('external_delivery.courier_name'), @get('external_delivery.courier_phone')].filter((v) -> v != '' && v != null).join(', ')
  ).property('external_delivery.courier_name', 'external_delivery.courier_phone')

  formattedPromos: (->
    if @get('status') is 'draft'
      @get('promos')
    else
      @get('promos').filter((p) -> p).map (promo) =>
        Ember.set promo, 'is_active', true
        promo
  ).property('promos', 'status')
  # ---
  # Записывает автоматически город, если среди городов
  # организации есть только один город
  # Выполнять на сохраненной модели!
  # ---
  fillDefaultCity: (autoSave=true) ->
    # TODO: получать список городов с сервера от организации
    @get('organization')
    .then (organization) =>
      organization.get('restaurants')
    .then (restaurants) =>
      cities = restaurants.map((r) => r.get('city'))
        .filter (city) => !Em.isEmpty(city)
        .uniq()

      promise = Em.RSVP.resolve()

      if cities.length is 1
        @set('city', cities[0])

        promise = @save() if autoSave

      promise

  marker: (->
    if @get('isDelayedTime')
      switch @get('status')
        when 'draft'     then 'images/map-markers/dots/order-draft-marker.png'
        when 'pending'   then 'images/map-markers/dots/pending-pending-marker.png'
        when 'confirm'   then 'images/map-markers/dots/pending-confirm-marker.png'
        when 'preparing' then 'images/map-markers/dots/pending-preparing-marker.png'
        when 'prepared'  then 'images/map-markers/dots/pending-prepared-marker.png'
        when 'delivery'  then 'images/map-markers/dots/pending-delivery-marker.png'
        when 'complete'  then 'images/map-markers/dots/pending-complete-marker.png'
        when 'undo'      then 'images/map-markers/dots/pending-undo-marker.png'
        else 'images/map-markers/dots/order-marker.png'
    else
      switch @get('status')
        when 'draft'     then 'images/map-markers/dots/order-draft-marker.png'
        when 'pending'   then 'images/map-markers/dots/order-pending-marker.png'
        when 'confirm'   then 'images/map-markers/dots/order-confirm-marker.png'
        when 'preparing' then 'images/map-markers/dots/order-marker.png'
        when 'prepared'  then 'images/map-markers/dots/order-prepared-marker.png'
        when 'delivery'  then 'images/map-markers/dots/order-delivery-marker.png'
        when 'complete'  then 'images/map-markers/dots/order-complete-marker.png'
        when 'undo'      then 'images/map-markers/dots/order-undo-marker.png'
        else 'images/map-markers/dots/order-marker.png'
  ).property('isDelayed', 'status')

# ---
# Доступные статусы заказа
# ---
Order.STATUSES = [
  'draft'
  'pending'
  'confirm'
  'preparing'
  'prepared'
  'delivery'
  'complete'
  'undo'
]

Order.PAYMENT_METHODS = [
  'cash'
  'card'
  'courier_card'
  'external_service_card_online'
]

module.exports = App.Order = Order
